export const PRICE_RANGE = [1, 999999] as const;
